import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarStatusService {
  private calendarStatusSource = new BehaviorSubject<boolean>(false);
  calendarStatus$ = this.calendarStatusSource.asObservable();

  constructor() { }

  updateCalendarStatus(status: boolean) {
    this.calendarStatusSource.next(status);
  }
}
